import React, { Component } from 'react';
import { translate } from 'react-i18next';

class Deposits extends Component {

  renderDeposit = (deposit, index) => {
    return (
      <tr key={index}>
        <td>{deposit.date}</td>
        <td>{"$" + Number(deposit.amount.toFixed(4)).toLocaleString("en-US") + " " + deposit.amount_cur}</td>
      </tr>
    );
  }

  renderDepositTable = () => {
    const { t } = this.props;
    return (
      <div>
        <label>{t('dashboard.invoices.label_deposits')}</label>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>{t('dashboard.invoices.col_date')}</th>
              <th>{t('dashboard.invoices.col_deposit')}</th>
            </tr>
          </thead>
          <tbody>
            {this.props.invoice.payments.map((deposit, index) =>
              this.renderDeposit(deposit, index)
            )}
          </tbody>
        </table>
      </div>
    );
  }

  renderAllDepositsTable() {
    const invoices = this.props.get_data_invoices
    const { t } = this.props;
    return (
      <div>
        <label>{t('dashboard.invoices.label_deposits')}</label>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>{t('dashboard.invoices.col_remission')}</th>
              <th>{t('dashboard.invoices.col_date')}</th>
              <th>{t('dashboard.invoices.col_deposit')}</th>
            </tr>
          </thead>
          <tbody>
            {invoices.map((invoice) =>
              this.rebderAllDeposit(invoice.payments, invoice.remission)
            )}
          </tbody>
        </table>
      </div>
    )
  }


  rebderAllDeposit = (deposits, remission) => {
    return (
      deposits.map((deposit, index) =>
        <tr key={index}>
          <td>{remission}</td>
          <td>{deposit.date}</td>
          <td>{"$" + parseFloat(deposit.amount.toFixed(4)).toLocaleString("en-US") + " " + deposit.amount_cur}</td>
        </tr>
      )
    )
  }

  render() {
    return (
      <div className="table-responsive">
        {this.renderAllDepositsTable()}
      </div>
    )
  }
}

export default translate('common')(Deposits);



// WEBPACK FOOTER //
// ./src/dashboard/invoices/Deposits.js